import React from 'react';
import PropTypes from 'prop-types';
import EditableLeafletPolygon from 'shared/editableLeafletPolygon';

function ELeafletPolygon({ 
  positions, 
  coatPositions, 
  showCoatStroke,
  contextMenu, 
  noException,
  onContextMenu, 
  skipCorridor, 
  map, 
  geometryIndex, 
  draggable, 
  resizable, 
  onChange,
  color,
  fillColor,
  fillOpacity,
  isException
}) {

  return <EditableLeafletPolygon  
  contextMenu={contextMenu}
  noException={noException}
  onContextMenu={onContextMenu}
  skipCorridor={skipCorridor}
  map={map}
  color={color}
  fillColor={fillColor}
  fillOpacity={fillOpacity}
  positions={positions}
  coatPositions={coatPositions}
  showCoatStroke={showCoatStroke}
  geometryIndex={geometryIndex}
  draggable={draggable}
  resizable={resizable}
  onChange={onChange}
  isException={isException}
  />;
}

ELeafletPolygon.propTypes = {
  positions: PropTypes.arrayOf(PropTypes.object),
  // geometryIndex: PropTypes.number.isRequired,
};

export default ELeafletPolygon;
